import { Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { COOKIESPREFIX } from '../../config.js';
import React, { useRef } from 'react'
import { Login } from '../../actions/actions';
import NavBar from './components/Navbar.js';
import SideMenu from './components/SideMenu.js';

import LoginPage from './Login.js';
import Home from './Home';
import Members from './Members.js';
import Events from './Events.js';
import EventsDetails from './EventsDetails.js';
import Partners from './Partners.js';
import PartnerDetails from './PartnerDetails.js';
import Tshop from './Tshop.js';
import TshopProduct from './TshopProduct.js';
import Contents from './Contents.js';
import ContentPromotionDetails from './ContentPromotionDetails.js';
import System from './System.js';
import Finance from './Finance.js';
import RegistrationForms from './RegistrationForms.js';
import RegistrionFormDetails from './RegistrionFormDetails.js';
import PageNotFound from '../PageNotFound.js'
import EmailModules from './EmailModules.js';
import EmailModuleDetails from './EmailModulesDetails.js';

function App(props) {
    const [cookies, setCookie, removeCookie] = useCookies([`${COOKIESPREFIX}_cred`, `${COOKIESPREFIX}_token`]);
    useEffect(() => {
        if(props.token.isLogin&& props.token.usertype!=='admin'){
            props.dispatch(Login(false));
        }
    }, [props.token])

    if(!props.token.isLogin||props.token.usertype!=='admin'){
        return(
            <LoginPage/>
        )
    }
    return (
        <div className="relative flex w-full h-full flex-col" style={{overflow:'hidden',maxHeight:'100vh',minHeight:'100vh'}}>
            <NavBar/>
            <div className='w-full flex flex-row'  style={{height:'calc(100% - 80px)',overflow:'hidden'}}>
                <SideMenu/>
                <div className='h-full' style={{width:'calc(100% - 250px)'}}>
                    <Routes >
                        <Route path="/" element={<Home />} />
                        <Route path="/members" element={<Members />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/events/:id" element={<EventsDetails />} />
                        <Route path="/partners" element={<Partners />} />
                        <Route path="/partners/:id" element={<PartnerDetails />} />
                        <Route path="/partners/tshop/:id" element={<TshopProduct />} />
                        <Route path="/contents" element={<Contents />} />
                        <Route path="/contents/promotions/:id" element={<ContentPromotionDetails />} />
                        {/* <Route path="/tshop" element={<Tshop />} /> */}
                        <Route path="/tshop" element={<Partners />} />
                        <Route path="/system" element={<System />} />
                        <Route path="/finance" element={<Finance />} />
                        <Route path="/registration-forms" element={<RegistrationForms />} />
                        <Route path="/registration-forms/:id" element={<RegistrionFormDetails />} />
                        <Route path="/email-modules" element={<EmailModules />} />
                        <Route path="/email-modules/:id" element={<EmailModuleDetails />} />
                        <Route path="/*" element={<PageNotFound />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(App)

